// extracted by mini-css-extract-plugin
module.exports = {"operation__wrapper":"OperationTag_operation__wrapper__P6nEw","operation__icon":"OperationTag_operation__icon__aOVw_","operation__title":"OperationTag_operation__title__3e1gJ"};